import React from 'react';
import PropTypes from 'prop-types';
import { PrismicRichText } from '@prismicio/react';
import { linkResolver } from '../../helpers/linkResolver';

import DownArrow from '../../images/downArrowWhite.svg';
import * as styles from './CardAnchorNavigation.module.scss';
import Container from '../../components/Layouts/Container';
import { getScrollPositionWidthOffset, htmlSafeID } from '../../helpers/helpers';

const CardAnchorNavigationSliceProps = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    background_colour: PropTypes.string,
    slice_id: PropTypes.string,
    label: PropTypes.string,
    text: PropTypes.string,
  })),
};

const CardAnchorNavigationSlice = ({
  items,
}) => {
  const onClickScrollLink = (event, id) => {
    event.preventDefault();
    getScrollPositionWidthOffset(id);
  };

  const CardContent = ({ item, index }) => (
    <div className={styles.cardContent}>
      <div className={styles.cardLabel}>0{index + 1}</div>
      <div className={styles.cardTitle}>
        {item.label}
        <span className={styles.cardArrow}>
          <img src={DownArrow} alt="" />
        </span>
      </div>
      {item.content && (
        <div className={styles.cardDescription}>
          <PrismicRichText field={item.content.richText} linkResolver={linkResolver} />
        </div>
      )}
    </div>
  );

  const TagAndContentAnchorNavigation = ({ item }) => (
    <a
      href={`#${htmlSafeID(item.slice_id)}`}
      onClick={(event) => onClickScrollLink(event, htmlSafeID(item.slice_id))}
      className={styles.cardLink}
    >
      <CardContent item={item} index={index} />
    </a>
  );

  const OtherAnchorNavigation = ({ item, index }) => (
    <a
      href={`#${htmlSafeID(item.slice_id)}`}
      key={index}
      onClick={(event) => onClickScrollLink(event, item.slice_id)}
      className={styles.cardLink}
    >
      <CardContent item={item} index={index} />
    </a>
  );

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.cardsContainer}>
          {items.map((item, index) => (
            <div 
              key={index} 
              className={styles.card}
              style={item.background_colour ? { backgroundColor: item.background_colour } : {}}
            >
              {item.id === 'tag_and_content' ? (
                <TagAndContentAnchorNavigation item={item} index={index} />
              ) : (
                <OtherAnchorNavigation item={item} index={index} />
              )}
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

CardAnchorNavigationSlice.propTypes = CardAnchorNavigationSliceProps;
CardAnchorNavigationSlice.defaultProps = CardAnchorNavigationSliceProps;

export default CardAnchorNavigationSlice;
